import { autoserialize, autoserializeAs } from 'cerialize';

import { isNullOrUndefined, DateUtil } from '@uzurv/core';
import { MiniDriver } from './mini-driver';

export class SignatureRequestStatus {
  @autoserialize
  signatureRequestId: string;

  @autoserialize
  status: string;

  @autoserialize
  documentNames: string;

  @autoserializeAs(MiniDriver)
  miniDriver: MiniDriver;

  @autoserializeAs(Date)
  signedDate: Date;

  @autoserializeAs(Date)
  createdDate: Date;

  @autoserializeAs(Date)
  lastUpdatedDate: Date;

  /**** Serialization ****/

  static OnSerialized(instance: SignatureRequestStatus, json: any): void {
    if (!isNullOrUndefined(instance.signedDate)) {
      json.signedDate = DateUtil.serializeDate(instance.signedDate);
    }

    if (!isNullOrUndefined(instance.createdDate)) {
      json.createdDate = DateUtil.serializeDate(instance.createdDate);
    }

    if (!isNullOrUndefined(instance.lastUpdatedDate)) {
      json.lastUpdatedDate = DateUtil.serializeDate(instance.lastUpdatedDate);
    }
  }

  static OnDeserialized(instance: SignatureRequestStatus, json: any): void {
    if (!isNullOrUndefined(json['signedDate'])) {
      instance.signedDate = DateUtil.deserializeLocalDate(json['signedDate']);
    }

    if (!isNullOrUndefined(json['createdDate'])) {
      instance.createdDate = DateUtil.deserializeLocalDate(json['createdDate']);
    }

    if (!isNullOrUndefined(json['lastUpdatedDate'])) {
      instance.lastUpdatedDate = DateUtil.deserializeLocalDate(json['lastUpdatedDate']);
    }
  }
}
